import React from 'react';

const CustomTooltip = ({ value }) => {
  if (!value) return null;

  // Split by commas and trim whitespace
  const items = value.split('\n').map(s => s.trim());
  console.log('items', items);
  return (
    <div className="ag-tooltip"
    style={{
      position: 'absolute',       // make it float above other components
      zIndex: 9999,               // ensure it appears on top
      whiteSpace: 'nowrap',       // prevent line breaks
      padding: '4px 8px',
      backgroundColor: 'var(--ag-tooltip-background, #f5f5f5)',
      color: 'var(--ag-tooltip-color, #000)',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
      borderRadius: '4px',
      pointerEvents: 'none',      // allows mouse events to pass through
    }}
    >
      <ul style={{ margin: 0, paddingLeft: '16px' }}>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default CustomTooltip;
